export default __webpack_public_path__ + "static/media/menu.52187546.svg";